import { dataTable } from './types';

export const budgetCategoriesMocksData: dataTable[] = [
  {
    id: '1',
    code: '00',
    name: 'OPERACIONS DE VIGILÀNCIA I AJUDA A LA VIALITAT',
    color: '#2563EB',
    budgetItemsCount: 15,
    state: 'active',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
  },
  {
    id: '2',
    code: '01',
    name: 'PAVIMENTS',
    color: '#DC2626',
    budgetItemsCount: 25,
    state: 'active',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
  },
  {
    id: '3',
    code: '02',
    name: 'DRENATGES',
    color: '#16A34A',
    budgetItemsCount: 18,
    state: 'active',
    isActive: true,
    createdAt: '2024-01-01T00:00:00Z',
    updatedAt: '2024-01-01T00:00:00Z',
  },
];

